module.exports = __webpack_public_path__ + "img/TC.1f29f6fb.png";